import Styled from 'styled-components'

export const Filtering = Styled.div`
margin-top: 90px;

cursor: pointer;
justify-content: center;
display: flex;
visibility: ${props => props.isBack && 'hidden'};


img{
    height: 20px;
}

p{
color: black;
font-weight: bold;
margin-left: 5px;
}
`

export const Filter = Styled.fieldset`

@media(max-width: 800px) {
 margin: 1%; 
}
legend{
    font-weight: bold;
}

.close{
    float: right;
    width: 24px;
    height: 24px;
    color: black;
    cursor: pointer;
}

p{
    font-weight: bold;
    color: #5F5F5F;
}



.applyFIlter{

width: 100%;
border: none;
margin-top: 20px;
font-weight: 600;
padding: 7px;
border-radius: 8px;
font-size: 14px;
}

.cleanFilter{
  width: 100%;
  margin-top: 20px;
  font-weight: 600;
  padding: 7px;
  border-radius: 8px;
  font-size: 14px;
  border: 1px solid #9FA9AE;
}

`

export const CheckboxContainer = Styled.div`
margin-top: 1px;
display: flex;
align-items: center;

label{
    padding-left: 10px;
    cursor: pointer;
    line-height: 20px;
    &:active{
        color: #263238;
    }
}
input[type=radio] {
    width: 18px;
    height: 18px;
    accent-color: #263238;
}
`

export const Radio = Styled.input`
  ::checked{
    color: #263238;
  }
`
export const ContentPrice = Styled.div`
margin-top: 30px;

p{
    margin-top: 10px;
}

`

export const Line = Styled.div`
border: 4px solid #ECEDF0;
background: #ECEDF0;
`

export const ContentRange = Styled.div`
margin-left: 14px;
margin-bottom: 10px;
`
export const LineSecond = Styled.div`
border: 1px solid #ECEDF0;
`

export const ContentBrandsAndCategories = Styled.div`

.title{
  color: black !important;
  font-size: 1rem;
}

.svgColorChanger{
    color: #0b3275;
}
`

export const ContainerFilter = Styled.div`
 height: 30px;
 .bg-light-green {
    background: #daede9;
 }
 .bg-light-grey {
    background: #e6e9ee;
 }
`

export const Counter = Styled.span`
 background:#00a867;
 border: 2px solid #FFFFFF;
 top: -2px !important;
 margin-left: 4px;
`

export const Form = Styled.form`
`

export const Center = Styled.div`
 display: flex;
 justify-content: center;
 font-size: 24px;
`

export const ValueSlider = Styled.div`
position: absolute;
margin-left: auto;
margin-right: auto;
left: 0;
right: 0;
top: 50%;
`